import { decryptInteger, encryptInteger } from "@/Utils/encryptInteger";
import Cookies from "js-cookie";
import { createContext, useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";

const BuyContext = createContext(null);

export const BuyProvider = ({ children }) => {
    const [openModal, setOpenModal] = useState({
        buy: false,
        login: false,
        create: false,
        otp: false,
        success: false,
        custom:false,
    });

    const [directOpen, setDirectOpen] = useState(true);
    const [loggedUserDetails, setLoggedUserDetails] = useState(null)

    const [createUserDetails, setCreateUserDetails] = useState();

    const [customModalData, setCustomModalData] = useState({
        showId:'',
        link:''
    })

    const [isCalled, setIsCalled] = useState(false)

    const [selectedIndex, setSelectedIndex] = useState(0)

    const [selectedState, setSelectedState] = useState({})

    const [selectedData, setSelectedData] = useState(null)

    const openSingleModal = (modalName) => {
        setOpenModal({
            buy: false,
            login: false,
            create: false,
            otp: false,
            success: false,
            [modalName]: true,
        });
    };

    const [modelMap, setModalMap] = useState(false)

    const [isSocial, setIsSocial] = useState(false)

    const [googleToken, setGoogleToken] = useState(null)

    const [selectedUser, setSelectedUser] = useState(null)

    const [locationDetails, setLocationDetails] = useState({
        city: "",
        state: ""
    });

    const openBuyModalData = (data) => {
        let encryptedData = encryptInteger(JSON.stringify(data));
        localStorage.setItem("modal_data", encryptedData)
    }

    const getBuyModalData = () => {
        setIsCalled(true)
        let decryptedData = localStorage.getItem("modal_data");

        if (decryptedData) {
            localStorage.removeItem("modal_data")
            return true
        } else {
            return false
        }
    }

    useEffect(() => {
        const encryptedData = localStorage.getItem("user_data");
        if (encryptedData) {
            try {
                const decryptedString = decryptInteger(encryptedData);
                const userData = JSON.parse(decryptedString);
                const expiresAt = new Date(userData.web_token_expires_at).getTime();
                if (Date.now() > expiresAt) {
                    toast.error("Seestion expired, Please Login Again..")
                    localStorage.removeItem("user_data");
                    Cookies.remove("user_data");
                } else {
                    setTimeout(() => {
                        setLoggedUserDetails({
                            status: true,
                            data: userData,
                            remove: false
                        })
                        Cookies.set("user_data", JSON.stringify(userData), {
                            expires: 10,
                            path: "/",
                            secure: true,
                            sameSite: "Lax",
                        })
                    }, 600);
                }
            } catch (error) {
                console.error("Decryption failed:", error);
                localStorage.removeItem("user_data");
                Cookies.remove("user_data");
            }
        } else {
            setLoggedUserDetails({
                status: false,
                data: "",
                remove: false
            })
        }

    }, [])

    useEffect(() => {
        if (loggedUserDetails?.remove) {
            setLoggedUserDetails({
                status: false,
                data: "",
                remove: false
            })
        }
    }, [loggedUserDetails])

    return (
      <BuyContext.Provider
        value={{
          openSingleModal,
          openBuyModalData,
          getBuyModalData,
          openModal,
          setOpenModal,
          directOpen,
          setDirectOpen,
          loggedUserDetails,
          setLoggedUserDetails,
          createUserDetails,
          setCreateUserDetails,
          isCalled,
          setIsCalled,
          modelMap,
          setModalMap,
          selectedIndex,
          setSelectedIndex,
          selectedState,
          setSelectedState,
          selectedData,
          setSelectedData,
          isSocial,
          setIsSocial,
          googleToken,
          setGoogleToken,
          selectedUser,
          setSelectedUser,
          customModalData,
          setCustomModalData,
          locationDetails,
          setLocationDetails,
        }}
      >
        {children}
      </BuyContext.Provider>
    );
};

export const useBuy = () => {
    const context = useContext(BuyContext);
    if (!context) {
        throw new Error("useBuy must be used within a BuyProvider");
    }
    return context;
};
